import { ADD_TO_ADMIN_POPUP, REMOVE_FROM_ADMIN_POPUP } from "../types";

export const addToAdminPopup = (data) => async (dispatch) => {
  try {
    console.log('data Add to Popup :>> ', data);
    dispatch({
      type: ADD_TO_ADMIN_POPUP,
      payload: data
    });
  } catch (err) {
    console.log('Set Vendor Access  ');
  }
};

export const removeFromAdminPopup = (data) => async (dispatch) => {
  try {
    dispatch({
      type: REMOVE_FROM_ADMIN_POPUP,
      payload: data
    });
  } catch (err) {
    console.log(err);
  }
};
